// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svc-credit-type {\n  position: absolute;\n  bottom: -30px;\n  z-index: 10;\n  text-align: left;\n  left: 0;\n  right: 0;\n  color: red;\n}", ""]);
// Exports
module.exports = exports;
